"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getWeekDays;

function getWeekDays() {
  return ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/WeekDayPicker/helpers/getWeekDays.js
// module id = rK3c
// module chunks = 0